export const SUPPORT_ADD_REPLY_ATTACHMENTS = 'SUPPORT_ADD_REPLY_ATTACHMENTS'
export const SUPPORT_REMOVE_REPLY_ATTACHMENTS = 'SUPPORT_REMOVE_REPLY_ATTACHMENTS'
export const SUPPORT_SET_CURRENT_TICKET = 'SUPPORT_SET_CURRENT_TICKET'
export const SUPPORT_SET_REPLY_ATTACHMENTS = 'SUPPORT_SET_REPLY_ATTACHMENTS'
export const SUPPORT_SET_TICKETS_SHIPMENTS = 'SUPPORT_SET_TICKETS_SHIPMENTS'
export const SUPPORT_SET_WAIT_FOR_TICKET_CREATED = 'SUPPORT_SET_WAIT_FOR_TICKET_CREATED'
export const SUPPORT_SET_DRAFT_TICKET = 'SUPPORT_SET_DRAFT_TICKET'
